export const testimonials = [
  {
    id: 1,
    name: '龙城霸主·小飞',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20game%20player%20avatar%20portrait%2C%20warrior%20character%20with%20golden%20armor%2C%20square%20icon%20style%2C%20game%20art&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '3年老玩家',
    rating: 5,
    content: '玩了三年征途国际，从最初的小白到现在的龙城霸主，这款游戏给了我太多热血和回忆。国战系统做得真的太好了，每周的国战都是我最期待的时刻，万人同屏的战斗场面让人热血沸腾！',
    date: '2026-08-05',
  },
  {
    id: 2,
    name: '清风揽月',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20game%20player%20avatar%20portrait%2C%20female%20mage%20character%20with%20elegant%20robe%2C%20square%20icon%20style%2C%20game%20art&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '帮派帮主',
    rating: 5,
    content: '作为帮主，最享受的就是带着帮派兄弟们一起打帮战。V8.0版本的跨服战场简直是神来之笔，终于可以和别的服务器的高手较量了。官方运营也很用心，每次活动都很有诚意。',
    date: '2026-08-03',
  },
  {
    id: 3,
    name: '一剑封喉',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20game%20player%20avatar%20portrait%2C%20archer%20character%20with%20bow%2C%20square%20icon%20style%2C%20game%20art&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '竞技场王者',
    rating: 5,
    content: 'PVP党表示非常满意！职业平衡做得越来越好，每个职业都有自己的特色和操作空间。弓手的操作手感一流，暴击流打法的爽感无与伦比。推荐给所有喜欢PK的玩家。',
    date: '2026-07-30',
  },
  {
    id: 4,
    name: '花开花落',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20game%20player%20avatar%20portrait%2C%20healer%20character%20with%20gentle%20expression%2C%20square%20icon%20style%2C%20game%20art&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '休闲玩家',
    rating: 4,
    content: '虽然是国战游戏，但休闲玩法也很丰富。每天做做日常任务、逛逛地图、收集时装，和朋友聊聊天，感觉非常惬意。画面也很精美，中国风的场景让人沉浸其中。',
    date: '2026-07-28',
  },
  {
    id: 5,
    name: '铁血战魂',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20MMORPG%20game%20player%20avatar%20portrait%2C%20heavy%20armored%20warrior%20with%20helmet%2C%20square%20icon%20style%2C%20game%20art&width=80&height=80&seq=avatar-05&orientation=squarish',
    role: '新晋玩家',
    rating: 5,
    content: '刚玩一个月，已经被深深吸引了。新手引导做得很好，很快就上手了。帮派里的老玩家也都很热情，带着我刷副本、打国战。强烈推荐给喜欢MMORPG的玩家！',
    date: '2026-07-25',
  },
];

export const aboutInfo = {
  brandName: '征途国际',
  brandIntro: '征途国际是一款以中国古代战国时期为背景的大型多人在线角色扮演游戏（MMORPG）。自上线以来，凭借宏大的世界观、热血的国战玩法、精美的画面表现和深度的社交系统，赢得了全球数千万玩家的喜爱。',
  history: [
    {
      year: '2021',
      title: '正式上线',
      description: '征途国际在中国大陆地区正式上线公测，首日注册用户突破100万，迅速成为MMORPG品类现象级产品。',
    },
    {
      year: '2022',
      title: '全球化扩展',
      description: '征途国际启动全球化战略，陆续在东南亚、日韩、欧美等地区上线，全球注册用户突破1000万。',
    },
    {
      year: '2023',
      title: '版本2.0革新',
      description: '发布2.0重大版本更新，全面升级游戏引擎，画面品质大幅提升，新增跨服组队等社交玩法。',
    },
    {
      year: '2024',
      title: '电竞赛事启航',
      description: '首届征途国际全球总决赛成功举办，来自10个国家和地区的顶级玩家同台竞技，总奖金池超过500万元。',
    },
    {
      year: '2025',
      title: '用户突破5000万',
      description: '全球累计注册用户突破5000万，DAU稳定在500万以上，持续领跑国战MMORPG品类。',
    },
    {
      year: '2026',
      title: 'V8.0跨服新纪元',
      description: '发布V8.0跨服战场版本，推出龙城争霸玩法，打破服务器壁垒，开启全服竞技新时代。',
    },
  ],
  stats: [
    { label: '全球注册用户', value: '5000万+', icon: 'ri-user-line' },
    { label: '日活跃玩家', value: '500万+', icon: 'ri-fire-line' },
    { label: '覆盖国家和地区', value: '150+', icon: 'ri-global-line' },
    { label: 'App Store评分', value: '4.8', icon: 'ri-star-line' },
  ],
  contact: {
    email: 'kefu@zhengtu.com',
    wechat: '征途国际',
    weibo: '@征途国际官方',
    qq: '800123456',
    address: '中国上海市浦东新区张江高科技园区征途大厦',
    workTime: '客服工作时间：每日 9:00 - 21:00',
  },
};